import Icon from '@katalon-studio/katalon-ui/Icon';
import React from 'react';
import colors from '../../../scss/colors.scss';

function ThumbsUpIcon({ color, textSize, type }) {
  return <Icon
    type={type}
    name="fa-thumbs-up"
    textSize={textSize}
    sx={{
      color,
    }}
    boundingSize={null}
    color={null}
  />;
}

ThumbsUpIcon.defaultProps = {
  color: colors.gray9,
  textSize: '1rem',
  type: 'fa-regular',
};

export default ThumbsUpIcon;
